/** @format */

import {
  Component,
  OnInit,
  AfterViewInit,
  Inject,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { DbService } from '../core/services/db.service';
import { AuthService } from '../core/services/auth.service';
import { Observable, lastValueFrom, map, take } from 'rxjs';
import { Notification } from '../core/models/notification.model';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from '../core/services/alert.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, AfterViewInit {
  @ViewChild('notificationDropdown', { static: false })
  notificationDropdown: NgbDropdown;
  configData;
  openSwitch = false;

  menu = [
    {
      label: '대시보드',
      icon: 'bx-home',
      link: '/dashboard',
    },
    {
      label: '회원관리',
      icon: 'bx-user',
      subItems: [
        {
          label: '일반회원',
          link: '/user-list',
        },
        {
          label: '도우미 회원',
          link: '/houseKeeper-list',
        },
        {
          label: '도우미 신청',
          link: '/houseKeeper-apply',
        },
      ],
    },
    {
      label: '업무관리',
      icon: 'bx-note',
      subItems: [
        {
          label: '청소예약목록(1회)',
          link: '/one-cleaning-reserve-list',
        },
        {
          label: '청소예약목록(정기)',
          link: '/regular-cleaning-reserve-list',
        },
        {
          label: '청소요청목록(1회)',
          link: '/one-cleaning-request-list',
        },
        {
          label: '청소요청목록(정기)',
          link: '/regular-cleaning-request-list',
        },
        {
          label: '청소취소목록',
          link: '/cleaning-cancel-list',
        },
        {
          label: '청소정산목록',
          link: '/cleaning-calculate-list',
        },
        {
          label: '리뷰목록',
          link: '/review-list',
        },
      ],
    },
    {
      label: '서비스관리',
      icon: 'bx-list-ul',
      subItems: [
        {
          label: '인트로',
          link: '/intro',
        },
        {
          label: '팝업',
          link: '/popup',
        },
        {
          label: '배너',
          link: '/banner-management',
        },
        {
          label: '1:1문의',
          link: '/inquiry',
        },
        {
          label: '자주 묻는 질문',
          link: '/faq',
        },
        {
          label: '공지사항',
          link: '/notice',
        },
        {
          label: '서비스 정보',
          link: '/service-info',
        },
        {
          label: '이벤트',
          link: '/event',
        },
        {
          label: '각종약관',
          link: '/terms',
        },
        {
          label: '가사도우미 교육',
          link: '/housekeeper-education',
        },
        // {
        //   label: '홈페이지 배너 관리',
        //   link: '/homepage-banner',
        // },
        // {
        //   label: '홈페이지 전화번호 관리',
        //   link: '/homepage-contacts',
        // },
      ],
    },
    {
      label: '정보관리',
      icon: 'bxs-star',
      subItems: [
        {
          label: '안내문구정보',
          link: '/information',
        },
        {
          label: '도우미채용정보',
          link: '/helper-recruitment',
        },
        {
          label: '회사정보',
          link: '/footer-setting',
        },
      ],
    },
    {
      label: '홈페이지 관리',
      icon: 'bxs-store',
      subItems: [
        {
          label: '홈페이지 메인타이틀 관리',
          link: '/homepage-text-management',
        },
        {
          label: '홈페이지 이미지관리',
          link: '/homepage-banner',
        },
        {
          label: 'SNS링크 관리',
          link: '/homepage-sns-management',
        },
        {
          label: '청소예약문의 관리',
          link: '/homepage-reservation-management',
        },
        {
          label: '창업교육문의 관리',
          link: '/homepage-inqury-management',
        },
      ],
    },
  ];

  routerUrl: string;

  constructor(
    // private eventService: EventService,
    private router: Router,
    @Inject(DOCUMENT) private document: any,
    private db: DbService,
    private auth: AuthService,
    private alertService: AlertService
  ) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        // this._activateMenuDropdown();
        this.routerUrl = event.url;
      }
    });
  }

  ngOnInit() {
    //사이드바 정의
    document.body.setAttribute('data-sidebar', 'dark');
    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };

    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };

    this.readMyUnreadNotifications();
    this.readMyNotifications();
  }

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  isCondensed = false;

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.body.classList.toggle('right-bar-enabled');
    this.onSettingsButtonClicked();
  }

  /**
   * On mobile toggle button clicked
   */
  onToggleMobileMenu() {
    this.isCondensed = !this.isCondensed;
    document.body.classList.toggle('sidebar-enable');
    document.body.classList.toggle('vertical-collpsed');

    if (window.screen.width <= 768) {
      document.body.classList.remove('vertical-collpsed');
    }
  }

  ngAfterViewInit() {
    // this._activateMenuDropdown();
  }

  toggleMenu(event) {
    event.currentTarget.nextElementSibling.classList.toggle('mm-show');
  }

  scrollable() {
    document.body.setAttribute('data-layout-scrollable', 'true');
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    // this.mobileMenuButtonClicked.emit();
    this.onToggleMobileMenu();
  }

  /**
   * Logout the user
   */
  logout() {
    this.auth.logoutUser().then(() => {
      this.router.navigate(['/account/login']);
    });
  }

  public hide() {
    document.body.classList.remove('right-bar-enabled');
  }

  open(list, menu, mi) {
    const activeTag = document.querySelector<HTMLElement>('.active');
    if (activeTag) {
      activeTag.classList.remove('active');
    }
    if (list.openSwitch) {
      console.log('close');
      list.openSwitch = false;
    } else {
      list.openSwitch = true;
      menu.forEach((ele) => {
        if (ele != list && ele.openSwitch == true) {
          ele.openSwitch = false;
        }
      });

      if (list.subItems && list.subItems.length > 0) {
        for (let index = 0; index < list.subItems.length; index++) {
          const element = list.subItems[index];

          if (element.link == this.routerUrl) {
            const aTag = document.querySelector<HTMLElement>(
              `.atag${mi}${index}`
            );
            aTag.classList.add('active');
          }
        }
      }
    }
  }

  close(aTag: HTMLElement) {
    aTag.classList.add('active');
    this.menu.forEach((ele: any) => {
      ele.openSwitch = false;
    });
  }

  // 알림
  unReadAlarmCount$: Observable<number>;
  notifications$: Observable<Notification[]>;

  // 나의 알림 불러오기
  readMyNotifications() {
    this.notifications$ = this.db.collection$('notifications', (ref) =>
      ref.where('uuid', '==', 'admin').orderBy('dateCreated', 'desc')
    );
  }

  // 나의 알림중에서 안읽은 알림 불러오기
  readMyUnreadNotifications() {
    this.unReadAlarmCount$ = this.db
      .collection$('notifications', (ref) =>
        ref.where('uuid', '==', 'admin').where('readSwitch', '==', false)
      )
      .pipe(map((notifications) => notifications?.length));
  }

  // 알림 상세 이동
  goDetail(url: Notification['url']) {
    this.router.navigate([url]);
    this.notificationDropdown.close();
  }

  // 읽음 처리
  async updateReadSwitch() {
    const unReadNotifications = await lastValueFrom(
      this.notifications$.pipe(
        map((data: Notification[]) => data.filter((v) => !v.readSwitch)),
        take(1)
      )
    );
    await Promise.all(
      unReadNotifications.map((notification) => {
        this.db.updateAt(`notifications/${notification.id}`, {
          readSwitch: true,
        });
      })
    );
  }

  // 모달 닫을 때 읽음처리
  readAlarm(ev) {
    if (ev === false) {
      this.updateReadSwitch();
    }
  }

  // 알림 전체 삭제
  deleteAllAlarms() {
    this.alertService
      .successConfirm('알림을 삭제하시겠습니까?')
      .then(async (ok) => {
        if (ok) {
          const notifications = await lastValueFrom(
            this.notifications$.pipe(take(1))
          );
          await Promise.all(
            notifications.map(async (notification) => {
              await this.db.delete(`notifications/${notification.id}`);
              this.alertService.swalToast('알림을 삭제했습니다.');
            })
          );
        }
      });
  }
}
